<template>
    <div>
        <v-form
                ref="form"
                v-model="valid"
                lazy-validation
        >
            <v-row>
                <v-col cols="12">
                    <v-form-base :col="12" :model="customer" :schema="schemaCustomer"/>
                </v-col>
                <v-col cols="6">
                    <v-form>
                        <h2>Contact</h2>
                        <v-form-base :col="12" :model="customer" :schema="schemaContact"/>
                    </v-form>
                </v-col>
                <v-col cols="6">
                    <v-form>
                        <h2>Accounts</h2>
                        <v-form-base :col="12" :model="customer" :schema="schemaAccounts"/>
                    </v-form>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
    import VFormBase from 'vuetify-form-base';

    const required = msg => v => !!v || msg
    const validEmail = msg => v => /.+@.+\..+/.test(v) || msg

    export default {
        components: {VFormBase},
        props: {
            customer: {
                type: Object
            },
        },
        data() {
            return {
                valid: true,
            }
        },
        computed: {
            schemaCustomer() {
                return {
                    company: {
                        type: 'text',
                        label: 'Customer Name',
                        required: true,
                        rules: [
                            required('Customer Name is required')
                        ]
                    },
                    customerShort: {type: 'text', label: 'Short Name'},
                    website: {type: 'text', label: 'Website'},
                    paymentTermsDays: {
                        type: 'number',
                        label: 'Payment Terms Days',
                        required: true,
                        rules: [
                            required('Payment Terms Days is required')
                        ]
                    },
                    comments: {type: 'textarea', label: 'Comments'},
                }
            },
            schemaContact() {
                return {
                    contactName: {type: 'text', label: 'Name'},
                    contactTitle: {type: 'text', label: 'Title'},
                    contactEmail: {
                        type: 'email',
                        label: 'E-Mail',
                        rules: [
                            validEmail('E-mail must be valid')
                        ]
                    },
                    contactPhone: {type: 'text', label: 'Phone', col: {cols: 8}},
                    contactExtension: {type: 'text', label: 'Extension', col: {cols: 4}},
                    contactAddress1: {type: 'text', label: 'Address1'},
                    contactAddress2: {type: 'text', label: 'Address2'},
                    contactAddress3: {type: 'text', label: 'Address3'},
                    contactTown: {type: 'text', label: 'Town'},
                    contactCounty: {type: 'text', label: 'County'},
                    contactPostcode: {type: 'text', label: 'PostCode'},
                }
            },
            schemaAccounts() {
                return {
                    accountsName: {type: 'text', label: 'Name'},
                    accountsTitle: {type: 'text', label: 'Title'},
                    accountsEmail: {
                        type: 'email',
                        label: 'E-Mail',
                        rules: [
                            validEmail('E-mail must be valid')
                        ]
                    },
                    accountsPhone: {type: 'text', label: 'Phone'},
                    accountsAddress1: {type: 'text', label: 'Address1'},
                    accountsAddress2: {type: 'text', label: 'Address2'},
                    accountsAddress3: {type: 'text', label: 'Address3'},
                    accountsTown: {type: 'text', label: 'Town'},
                    accountsCounty: {type: 'text', label: 'County'},
                    accountsPostcode: {type: 'text', label: 'PostCode'},
                }
            },
        },
        methods: {
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            resetValidation () {
                this.$refs.form.resetValidation()
            },
            isValid() {
                return this.valid
            },
        },
    }
</script>

<style scoped>

</style>